<p-toast position="top-right" key="msj"></p-toast>
<p-confirmDialog [style]="{width: '450px'}"
                 [baseZIndex]="10000"
                 acceptLabel="Aceptar"
                 rejectLabel="Cancelar"
                 rejectButtonStyleClass="p-button-text">
</p-confirmDialog>

<div class="login-wrapper">
    <div class="split-card shadow-8">
        
        <div class="side-image">
            <div class="overlay-content">
            </div>
        </div>

        <div class="side-form">
            <div class="form-content w-full">
                <div class="mb-5">
                    <h3 class="text-900 font-bold text-2xl m-0">Iniciar Sesión</h3>
                    <p class="text-600 mt-2">Ingrese sus credenciales para continuar</p>
                </div>

                <form [formGroup]="form" (ngSubmit)="inicioSesionUsuario()">
                    
                    <!-- USUARIO -->
                    <div class="field mb-4">
                        <label for="username" class="block text-900 font-medium mb-2">Usuario</label>
                        <span class="p-input-icon-left w-full">
                            <i class="pi pi-user text-500"></i>
                            <input pInputText 
                                   id="username" 
                                   formControlName="UserName" 
                                   placeholder="Ingrese su usuario" 
                                   class="w-full custom-input custom-input-with-icon" 
                                   [ngClass]="{'ng-invalid ng-dirty': form.get('UserName')?.invalid && form.get('UserName')?.touched}"/>
                        </span>
                        <small *ngIf="form.get('UserName')?.invalid && form.get('UserName')?.touched" class="p-error block mt-1">
                            {{getErrors(error_email,'UserName')}}
                        </small>
                    </div>

                    <!-- CONTRASEÑA -->
                    <div class="field mb-4">
                        <label for="password" class="block text-900 font-medium mb-2">Contraseña</label>
                        
                        <div class="password-wrapper p-input-icon-left w-full">
                            <!-- Ícono de candado a la izquierda -->
                            <i class="pi pi-lock text-500"></i>

                            <input 
                                pInputText
                                [type]="showPassword ? 'text' : 'password'"
                                id="password"
                                formControlName="Password"
                                placeholder="Ingrese su contraseña"
                                class="w-full custom-input custom-input-with-icon"
                                [ngClass]="{'ng-invalid ng-dirty': form.get('Password')?.invalid && form.get('Password')?.touched}"
                                (keyup.enter)="inicioSesionUsuario()"
                            />

                            <!-- Ojo a la derecha -->
                            <button
                                type="button"
                                class="password-toggle-btn"
                                (click)="showPassword = !showPassword">
                                <i class="pi" [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
                            </button>
                        </div>

                        <small *ngIf="form.get('Password')?.invalid && form.get('Password')?.touched" class="p-error block mt-1">
                            {{getErrors(error_contrasenia,'Password')}}
                        </small>
                    </div>

                    <!-- CAPTCHA / COOKIE -->
                    <div *ngIf="form.controls['Cookie'].invalid && form.controls['Cookie'].touched" class="mb-3 text-center">
                        <small class="p-error font-bold">{{getErrors(error_captcha,'Cookie')}}</small>
                    </div>

                    <!-- BOTÓN -->
                    <button pButton pRipple type="submit" 
                            label="INGRESAR" 
                            class="w-full p-button-lg custom-button mt-2" 
                            [loading]="loading">
                    </button>

                    <div class="text-center mt-4">
                        <a href="#" class="text-600 font-medium no-underline hover:text-primary transition-colors">
                            ¿Olvidó su contraseña?
                        </a>
                    </div>
                </form>
            </div>
            
            <div class="copyright text-center text-500 text-sm mt-5">
                Copyright ©{{anio}} Todos los derechos reservados.
            </div>
        </div>
    </div>
</div>
<!-- SPINNER GLOBAL MODERNO (overlay) -->
<div class="fullscreen-spinner" *ngIf="loading">
  <div class="spinner-ring"></div>
</div>